import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WebcalendarOM_Main.html?raw';
import on from 'dojo/on';
import MainProperties from '../../WebCalendar_TS/MainProperties/MainProperties';
import "../../WebCalendar_TS/MainProperties/MainProperties";
import EvBookingEditor from '../../EvBookingEditor/EvBookingEditor';
import "../../EvBookingEditor/EvBookingEditor";
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class WebcalendarOM_Main extends compose(_WidgetBaseSP) {
    
    templateString: any = template;

    private mainProperties: MdsLax<InstanceType<typeof MainProperties>>;
    private currentBookingEditor: MdsLax<InstanceType<typeof EvBookingEditor>> = null;
    private bookingEditingEnabledForCurrentUser: boolean = false;

    evBookingEditorSectionsConfig: EvBookingEditor_SectionsConfig = {
        isBookerSectionVisible: false,
        isTicketSectionVisible: true,
        isCastListVisible: true,
        isProgramListVisible: true,
        isEvTasksListVisible: true,
        isServiceListVisible: true,
        isOrchesterEmployementsListVisible: true,
        isEvCategoriesListVisible: true,
        isFilesSectionVisible: true
    };

    private _calendarCreated() {

        on(this.mainProperties.calendar, "viewtypeChange", lang.hitch(this, this._viewtypeChanged));

    }
    _viewtypeChanged(data: any) {
        //console.debug("_viewtypeChanged", data);
    }

    showBookingDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        this.mainProperties.openDefaultDetailView(item); // mal standard aufrufen

        // ... aber erweitern: Daten für den Editor requesten

        let dlg = this.mainProperties.itemClickDlg;


        if (this.bookingEditingEnabledForCurrentUser == true && item.editable == true) {
            dlg.setUserdefinedButton(window.translations["WebCalendar__DetailViewDlg_label_editButton"], null, lang.hitch(this, function () {
                this._onclickOpenBookingEditor(item);
            }), false);

            if (this.hasUserRole("OM")) {
                dlg.addButton("gotoMatrix",
                    window.translations["WebCalendar__DetailViewDlg_label_matrixButton"],
                    lang.hitch(this, function () {
                        //this.StandbyStart(this.itemClickDlg.domNode);
                        //this.itemClickDlg.close();
                        window.location.href = window.appRoot + "Home/OM?directBookingId=" + item.id;
                    }),
                    null,
                    null,
                    "fas fa-border-none"
                );
            }

        }


        dlg.show();
    }

    private _checkIfBookingEditingEnabledForCurrentUser(): void {

        this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"], lang.hitch(this, this._showBookingEditorInterface));
    }

    private _showBookingEditorInterface(bool?: boolean): void {
        //console.log("_showBookingEditorInterface", bool);
        this.bookingEditingEnabledForCurrentUser = bool === true;

        if (this.bookingEditingEnabledForCurrentUser == true) {

            let icon = this.createFontawesomeIcon("fas fa-plus-circle", "&nbsp;");

            let createBookingBtn = this.UiModder.domConstruct.create("BUTTON", {
                innerHTML: icon.outerHTML + this.translations["WebCalendar_SidebarPane_btnLabel_createBooking"],
                className: "mds-button-base round hoverDark w3-block",
                onclick: lang.hitch(this, this._onclickOpenBookingEditor)
            });

            this.mainProperties.addCustomPane("evBookingEditorPane", this.translations["WebCalendar_SidebarPane_paneLabel_bookingEditor"], createBookingBtn, "fas fa-calendar-plus");
            this.mainProperties.addTopButton("createBooking",
                this.translations["WebCalendar_SidebarPane_btnLabel_createBooking"],
                lang.hitch(this, this._onclickOpenBookingEditor),
                true,
                false,
                "fas fa-plus-circle"
            );

        } else {
            this.mainProperties.removePane("evBookingEditorPane");
        }
    }

    private _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainProperties();

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));
        
        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showBookingDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl: 
            },
            userProperties: {
                customFunctionName: "Webtool_API_Webcalendar__GetUserProperties",
                requestUrl: "Calendar/GetUserProperties",
                //requestParams: [{ name: "jsonData", value: { user: "unknown" } }]
            },
            defaultDisplaySettings: {
                b_show_end_time: true,
                //hideColumnHead: true
            },
            
        });
        
        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        //this.mainProperties.setTitles(
        //    this.stringFormat(this.translations["KWittCalendar__MainTitle"], this.translations["MainTitle"]),
        //    this.translations["KWittCalender__Title"]);

    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

        //props.addCustomPane(....)

    }

    private _doubleClickFct(clickedDate: Date) {
        if (this.bookingEditingEnabledForCurrentUser == true) {
            this._onclickOpenBookingEditor(null);

            if (this.currentBookingEditor != null) {
                this.currentBookingEditor.editorForm.dateStartInput.setValue(clickedDate);
            }
        }
}

    private _onclickOpenBookingEditor(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        if (this.bookingEditingEnabledForCurrentUser == true) {

            if (this.mainProperties.itemClickDlg && this.mainProperties.itemClickDlg._destroyed != true) {
                try {

                    this.mainProperties.itemClickDlg.close();
                } catch (ex) {
                    // nich so schlümm
                }
            };


            if (this.currentBookingEditor != null) {
                if (this.currentBookingEditor._destroyed !== true) this.currentBookingEditor.destroy();
                this.currentBookingEditor = null;
            }

            this.currentBookingEditor = new EvBookingEditor();
            this.currentBookingEditor.setEvBookingEditorConfig(this.evBookingEditorSectionsConfig);

            if (item) {
                this.currentBookingEditor.loadEntityById(item.id);
            }
            this.currentBookingEditor.showBookingEditorForm();

            this.currentBookingEditor.on("saveDataResponse", lang.hitch(this, this._onUpdateItemChanges_Response));
        } else {
            alert("Current User has no permissions for booking editor")
        }
    }

    private _onUpdateItemChanges_Response(response: string) {
        this.mainProperties._onUpdateItemChanges_Response(response);
    }


    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();

        this._checkIfBookingEditingEnabledForCurrentUser();

    }

}

export default mdsWidget(WebcalendarOM_Main);